'use client'

import { Affix, Button, Flex } from '@mantine/core'
import { IconSparkles } from '@tabler/icons-react'
import { usePathname } from 'next/navigation'
import { tokens } from '@nile/mantine-theme/theme/styles/variables'
import { useGeneralAiStatus, type GenAiIngressSource } from '@/hooks/useGeneralAiStatus'
import { useGeneralAiAvailable } from '@/hooks/useGeneralAiAvailable'
import { isStoreCategoryPath } from '@/types/enums/StoreTypes'
import { isStoreHomePage } from '@/lib/namedRoutes'

interface GeneralAiFabProps {
    ingress?: 'fab_store' | 'fab_account' | 'fab_care_plan' | 'fab_lab_results'
}

export default function GeneralAiFab({ ingress = 'fab_store' }: GeneralAiFabProps) {
    const pathname = usePathname()
    const { hasExistingConversation, isLoading: isStatusLoading, navigateToGeneralAi } = useGeneralAiStatus()
    const isCategoryRoute = pathname ? isStoreCategoryPath(pathname) : false
    const generalAiAvailable = useGeneralAiAvailable()
    // Store home docks universal search at the bottom on mobile, which covers this FAB.
    const hideOnMobile = pathname ? isStoreHomePage(pathname) : false

    if (!generalAiAvailable || isStatusLoading || isCategoryRoute) {
        return null
    }

    const buttonText = hasExistingConversation ? 'Ask AI' : 'Try General AI'
    return (
        <Affix
            position={{ bottom: 20, right: 20 }}
            zIndex={1000}
            visibleFrom={hideOnMobile ? 'sm' : undefined}
            data-testid="general-ai-fab"
        >
            <Button
                onClick={() => navigateToGeneralAi(ingress as GenAiIngressSource)}
                h="var(--spacing-52, 52px)"
                px="lg"
                style={{
                    background: tokens.gradients.genai,
                    color: 'white',
                }}
            >
                <Flex justify="center" align="center" gap={8}>
                    <IconSparkles size={20} color="white" />
                    {buttonText}
                </Flex>
            </Button>
        </Affix>
    )
}
